import React from "react";
import ReactTags from "react-tag-autocomplete";


class ProxySubnetsUseCases extends React.Component {
    state = {
        use_cases: [],
        use_cases_suggestions: this.props.useCases
    };

    componentDidMount() {
        this.inputRef = React.createRef();
        let use_cases = [];
        
        this.props.subnet.use_cases.forEach(useCase => {
            use_cases.push({slug: useCase.slug, name: useCase.use_case}); 
        });

        this.setState({use_cases});
    }

    onDelete(i) {
        const use_cases = this.state.use_cases.slice(0);
        use_cases.splice(i, 1);
        this.setState({ use_cases }, () => {
            this.props.updateSubnet(this.props.subnet);
        });

        use_cases.map((use_case) => {
            use_case.use_case = use_case.name; 
            return use_case;
        });
        
        this.props.toggleCell(this.props.subnet.id, 'use_cases', use_cases);
    }

    onAddition(tag) {
        const use_cases = [].concat(this.state.use_cases, tag);
        this.setState({ use_cases }, () => {
            this.props.updateSubnet(this.props.subnet);
        });

        use_cases.map((use_case) => {
            use_case.use_case = use_case.name; 
            return use_case;
        });
    
        this.props.toggleCell(this.props.subnet.id, 'use_cases', use_cases);
    }

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" >
                    <ReactTags
                        ref={this.inputRef}
                        tags={this.state.use_cases}
                        allowNew={true}
                        suggestions={this.props.useCases}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)}
                        placeholderText="Add Use Case" 
                        addOnBlur={true} 
                    />
                </form>
            </React.Fragment>
        );
    }
}

export default ProxySubnetsUseCases;
